module.exports = __webpack_public_path__ + "teqbahn-assets/media/MariaGargano.a444b13f.JPG";